export enum AppViews {
  Analyses = 'ANALYSES',
  Companies = 'COMPANIES',
  ContactUs = 'CONTACT_US',
  InvestmentCompanies = 'INVESTMENT_COMPANIES',
  Investments = 'INVESTMENTS',
  Pitch = 'PITCH',
  Pitches = 'PITCHES',
  Questions = 'QUESTIONS',
  SecondHandMarket = 'SECOND_HAND_MARKET',
  SelfPublishes = 'SELF_PUBLISHES',
  Subscriptions = 'SUBSCRIPTIONS',
  Transfer = 'TRANSFER',
  User = 'USER',
  Users = 'USERS'
}

export enum ContentType {
  Company = 'company',
  Investment = 'investment',
  InvestmentCompany = 'investmentcompany',
  Pitch = 'pitch',
  SelfPublish = 'pitchselfpublish',
  User = 'customuser'
}

export enum FileStatus {
  Deleted = 'deleted',
  Uploaded = 'uploaded'
}

export enum SearchFieldName {
  Filter = 'filter',
  Name = 'name',
  Search = 'search'
}

export enum SelfPublishFileStatus {
  Bad = 'bad',
  Good = 'good',
  Unchecked = 'unchecked'
}

export enum SwitchViews {
  Analyses = 'ANALYSES',
  InvestmentCompanies = 'INVESTMENT_COMPANIES',
  Investments = 'INVESTMENTS',
  InvitedInvestors = 'INVITED_INVESTORS',
  KYC = 'KYC',
  PitchChangesHistory = 'PITCH_CHANGES_HISTORY',
  Questions = 'QUESTIONS',
  Subscribers = 'SUBSCRIBERS',
  Subscriptions = 'SUBSCRIPTIONS',
  Users = 'USERS',
  PepChecksList = 'PEP_CHECKS_LIST'
}
